import { Weekday, RRule} from "rrule";

export function isBlankOrEmpty(value: string): boolean {
    if (value === null || value === undefined) return true;
    if (value == '') return true;
    if (value.trimEnd() == '') return true;
    return false
}

export function formatDayMonth(date:Date) {
  const d = new Date(date);

  const day = d.getDate();
  const month = d.toLocaleString("en-GB", { month: "long" });

  const suffix =
    day % 10 === 1 && day !== 11 ? "st" :
    day % 10 === 2 && day !== 12 ? "nd" :
    day % 10 === 3 && day !== 13 ? "rd" :
    "th";

  return `${day}${suffix} ${month}`;
}

export function formatWeekday(date:Date) {
  return new Date(date).toLocaleString("en-GB", { weekday: "long" });
}


export function isWeekend(date: Date): boolean {
    const day = date.getDay();
    return day === 0 || day === 6;
}

export function getLastWorkingDayOfMonth(year: number, month: number): Date {
    const d = new Date(year, month + 1, 0); // last day of month
    while (d.getDay() === 0 || d.getDay() === 6) {
        d.setDate(d.getDate() - 1);
    }
    return d;
}

export function getLastWorkingDayOfYear(year: number): Date {
    const d = new Date(year, 11, 31); // Dec 31
    while (d.getDay() === 0 || d.getDay() === 6) {
        d.setDate(d.getDate() - 1);
    }
    return d;
}

export function hasSpecificDateConstraint(rule: string): boolean {
    const r = rule.toUpperCase();

    return (
        r.includes("BYDAY=") ||
        r.includes("BYMONTHDAY=") ||
        r.includes("BYYEARDAY=") ||
        r.includes("BYMONTH=") ||
        r.includes("BYWEEKNO=")
    );
}

export function getLastDayOfWeek(isFullWeek: boolean): number {
    // rrule weekday: Mon=0, Tue=1, Wed=2, Thu=3, Fri=4, Sat=5, Sun=6
    return isFullWeek ? 6 : 4;
}

export function isLastWorkingDayOfYear(date: Date): boolean {
    const lastWorking = getLastWorkingDayOfYear(date.getFullYear());
    return (
        date.getFullYear() === lastWorking.getFullYear() &&
        date.getMonth() === lastWorking.getMonth() &&
        date.getDate() === lastWorking.getDate()
    );
}